var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CrudService, Resource } from '../client';
import { injectable } from 'tsyringe';
/**
 * AuthService is a service class that extends the CrudService class.
 * It provides methods to interact with the 'auth' resource.
 *
 * @class AuthService
 * @augments {CrudService<never, {authenticated: boolean}>}
 */
let AuthService = class AuthService extends CrudService {
    /**
     * Checks if the user is authenticated.
     *
     * It sends a GET request to the 'auth' resource and returns the 'authenticated' status.
     *
     * @returns {Promise<boolean>} A promise that resolves to the 'authenticated' status of the user.
     */
    async isAuthenticated() {
        return this
            .getOne()
            .then(res => res.data.authenticated);
    }
};
AuthService = __decorate([
    injectable(),
    Resource('auth')
    // eslint-disable-next-line require-jsdoc
], AuthService);
export { AuthService };
//# sourceMappingURL=auth.service.js.map